export default __webpack_public_path__ + "static/1405-e5fcc6a9b5d9ba227059c096a62a23ed.gif";